import { isNil } from 'lodash';

import fromAnyToNoBlankSpace from 'utils/converters/string/fromAnyToNoBlankSpace.util';
import withOptions from 'utils/functions/withOptions.util';

const validateName = withOptions(({ value }) => {
  // returning null indicates not only invalid, but not a string
  if (isNil(value)) return null;

  const lenValue = value.length;
  if (isNil(lenValue)) return null;

  const string = fromAnyToNoBlankSpace(value);
  const lenString = string.length;

  return lenString !== 0 && lenValue <= 200;
});

// noinspection JSUnusedGlobalSymbols
export default validateName;
